interface ListingPlaceholderProps {
  className?: string;
}

export function ListingPlaceholder({ className = "" }: ListingPlaceholderProps) {
  return (
    <div
      className={`flex h-full w-full items-center justify-center bg-gradient-to-br from-amber-50 via-orange-50 to-rose-50 ${className}`}
    >
      <svg
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-2/5 w-2/5 max-h-24 max-w-24 opacity-40"
      >
        {/* Camera body */}
        <rect
          x="22"
          y="40"
          width="76"
          height="52"
          rx="8"
          stroke="currentColor"
          strokeWidth="3"
          className="text-amber-400"
          fill="none"
        />
        {/* Camera lens */}
        <circle
          cx="60"
          cy="66"
          r="16"
          stroke="currentColor"
          strokeWidth="3"
          className="text-amber-400"
          fill="none"
        />
        <circle
          cx="60"
          cy="66"
          r="9"
          stroke="currentColor"
          strokeWidth="2"
          className="text-amber-300"
          fill="none"
        />
        {/* Camera top bump */}
        <path
          d="M44 40V34a4 4 0 014-4h24a4 4 0 014 4v6"
          stroke="currentColor"
          strokeWidth="3"
          className="text-amber-400"
          strokeLinecap="round"
        />
        {/* Flash dot */}
        <circle cx="86" cy="50" r="3" className="fill-amber-300" />
      </svg>
    </div>
  );
}
